var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9716_1043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6 12H2.4V21.6C2.4 22.2365 2.65286 22.847 3.10294 23.2971C3.55303 23.7471 4.16348 24 4.8 24H10.8V12H3.6ZM19.2 12H13.2V24H19.2C19.8365 24 20.447 23.7471 20.8971 23.2971C21.3471 22.847 21.6 22.2365 21.6 21.6V12H19.2ZM20.1492 6C20.3237 5.41622 20.4083 4.80925 20.4 4.2C20.4 1.884 18.516 0 16.2 0C14.2536 0 12.954 1.7784 12.1152 3.702C11.2884 1.884 9.9228 0 7.8 0C5.484 0 3.6 1.884 3.6 4.2C3.6 4.9152 3.6948 5.5068 3.8508 6H0V10.8H10.8V8.4H13.2V10.8H24V6H20.1492ZM6 4.2C6 3.2076 6.8076 2.4 7.8 2.4C8.8656 2.4 9.8568 4.23 10.4376 6H7.2C6.7512 6 6 6 6 4.2ZM16.2 2.4C17.1924 2.4 18 3.2076 18 4.2C18 6 17.2488 6 16.8 6H13.8276C14.4396 4.1088 15.3288 2.4 16.2 2.4Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9716_1043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftWhite);
export default __webpack_public_path__ + "static/media/gift_white.f4e6ce3b4b31c79bcf788729a447bd02.svg";
export { ForwardRef as ReactComponent };